import React from "react";
import PropTypes from "prop-types";
//Limitless imports
import { CompactKnowledgeBase, ExtraCustomerInfo, Classification, SecureData, getCustomerData } from "../../../..";
import ConversationTabs from "../../conversation-tabs/ConversationTabs";
import ConversationRespondPanelFooter from "./ConversationRespondPanelFooter";
import ConversationTabContent from "../conversation-tab-content/ConversationTabContent";
import { useExpertProfileContext } from "@limitless/expert";
import { useExpertAIReviewContext } from "../../../../../expert/hooks/expert-ai-review/ExpertAIReviewManagerContext";
const ConversationRespondPanel = ({
  message,
  messageResources
}) => {
  var _message$conversation2;
  const {
    profile
  } = useExpertProfileContext();
  const [customerSecureData, setCustomerSecureData] = React.useState([]);
  const {
    aiReviewData,
    isAIDraftSelected
  } = useExpertAIReviewContext();
  const {
    conversationState
  } = message;
  let startingTab = 3;
  if (conversationState.showClassification) {
    startingTab = 0;
  } else if (conversationState.showExtraInfo) {
    startingTab = 1;
  }
  const fetchCustomerSecureData = React.useCallback(() => {
    if (message !== null && message !== void 0 && message.secureDataEnabled) {
      getCustomerData(message, profile, secureData => {
        setCustomerSecureData(secureData.data || []);
      });
    }
  }, [message, profile]);
  React.useEffect(() => {
    fetchCustomerSecureData();
  }, [fetchCustomerSecureData]);
  React.useEffect(() => {
    var _message$conversation;
    if (message !== null && message !== void 0 && (_message$conversation = message.conversationState) !== null && _message$conversation !== void 0 && _message$conversation.secureData) {
      setCustomerSecureData(message.conversationState.secureData);
    }
  }, [message === null || message === void 0 ? void 0 : (_message$conversation2 = message.conversationState) === null || _message$conversation2 === void 0 ? void 0 : _message$conversation2.secureData]);
  const [activeTab, setActiveTab] = React.useState(startingTab);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ConversationTabs, {
    activeTab: activeTab,
    onTabChange: setActiveTab,
    message: message,
    showSecureData: conversationState.allowSecureDataRequest,
    secureData: customerSecureData
  }), /*#__PURE__*/React.createElement(ConversationTabContent, null, activeTab === 0 && /*#__PURE__*/React.createElement(Classification, {
    message: message,
    messageResources: messageResources,
    aiReviewData: aiReviewData,
    isAIDraftSelected: isAIDraftSelected
  }), activeTab === 1 && /*#__PURE__*/React.createElement(ExtraCustomerInfo, null), activeTab === 2 && /*#__PURE__*/React.createElement(SecureData, {
    message: message
  }), activeTab === 3 && /*#__PURE__*/React.createElement(CompactKnowledgeBase, {
    isKnowledgeActive: message.knowledgeBaseIsActive
  })), /*#__PURE__*/React.createElement(ConversationRespondPanelFooter, null));
};
export default ConversationRespondPanel;
ConversationRespondPanel.propTypes = {
  message: PropTypes.object.isRequired,
  messageResources: PropTypes.object.isRequired
};